import { useState } from "react";
import { useDispatch } from "react-redux";
import classes from "./RefineDialog.module.css";
import { mainActions } from "../../../store";
import Button from "../../UI/Button";
import BoundaryDragChart from "./BoundaryDragChart";
// props.src = the image source
// props.index = the chart index
// props.width = the image width.
// props.height the image height.
const RefineDialog = (props) => {
  const dispatch = useDispatch();
  const [removeNotes, setRemoveNotes] = useState(false);

  const deleteButtonHandler = () => {
    dispatch(mainActions.deleteRefineDataElement(props.index));
  };

  const duplicateButtonHandler = () => {
    dispatch(mainActions.duplicateRefineDataElement(props.index));
  };

  return (
    <div className={classes.outerBox} role="group" aria-label={`Chart ${props.number}`} data-refine-card-id={props.history.id}>
      <div className={classes.innerBox}>
        <div className={classes.container} data-tour-target="refine-diagram">
          <BoundaryDragChart
            src={props.src}
            width={props.width}
            height={props.height}
            chartData={props.chartData}
            fullChartData={props.fullChartData}
            noteIds={props.noteIds}
            removeNotes={removeNotes}
            onFinishRemoving={() => setRemoveNotes(false)}
            frets={props.frets}
            index={props.index}
          />
        </div>
        <div className={classes.lowerButtonContainer}>
          <Button className={classes.noteTool} data-tour-target="refine-remove" aria-pressed={removeNotes} onClick={() => setRemoveNotes(!removeNotes)}>{removeNotes ? "Done" : "Remove notes"}</Button>
          <div className={`${classes.actionGroup} ${classes.historyGroup}`} role="group" aria-label="Chart history" data-tour-target="refine-history">
            <Button disabled={!props.history.past.length} onClick={() => dispatch(mainActions.undoChart(props.history.id))}>Undo</Button>
            <Button disabled={!props.history.future.length} onClick={() => dispatch(mainActions.redoChart(props.history.id))}>Redo</Button>
          </div>
          <div className={classes.actionGroup} role="group" aria-label="Chart actions" data-tour-target="refine-actions">
            <Button onClick={deleteButtonHandler}>Delete</Button>
            <Button onClick={duplicateButtonHandler}>Duplicate</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefineDialog;
